import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage';

@Injectable({
    providedIn: 'root'
})
export class UserProvider {

    constructor(public storage: Storage) {
    }

    setVersion(version: any): Promise<any> {
        return this.storage.set('version', version);
    }

    getVersion(): Promise<any> {
        return this.storage.get('version');
    }
}
